import { MediaType } from './types';
import { IDSContentfulMedia } from '@ids/types/contentful';

export const isSupportedImageType = /(png|jpg|jpeg|webp)$/;

export const useMediaType = (media?: IDSContentfulMedia): MediaType => {
    if (media?.video?.videoFile) {
        return 'video';
    }

    if (media?.image && isSupportedImageType.test(media.image.file.contentType)) {
        return 'image';
    }

    return 'unsupported';
};
